import { joinStrings } from "@/lib/joinString"
import { careProviderSearchQuery$data } from "@/modules/care-provider/simple-search/__generated__/careProviderSearchQuery.graphql"
import { getHighlightValue } from "@/modules/care-provider/utils/get-highlight-value"

export type HighlightsSearchObject = careProviderSearchQuery$data["ch_careProviderSearch"]["results"][0]["highlights"]

interface FormatCareProviderName {
  firstName?: string | null
  lastName?: string | null
  businessName?: string | null
  title?: string | null
  highlights?: HighlightsSearchObject
}

export const combineCareProviderTitle = (
  { firstName, lastName, businessName, title }: FormatCareProviderName,
  highlights?: HighlightsSearchObject,
) => {
  return joinStrings(
    [
      getHighlightValue(highlights, "businessName", businessName),
      title,
      getHighlightValue(highlights, "firstName", firstName),
      getHighlightValue(highlights, "lastName", lastName),
    ],
    " ",
  )
}

export const combineConditionalCareProviderTitle = (
  {
    firstName,
    lastName,
    businessName,
    title,
    relationBusinessName,
  }: FormatCareProviderName & {
    relationBusinessName?: string | null
  },
  highlights?: HighlightsSearchObject,
) => {
  if (relationBusinessName === businessName && (firstName || lastName)) {
    return joinStrings(
      [
        title,
        getHighlightValue(highlights, "firstName", firstName),
        getHighlightValue(highlights, "lastName", lastName),
      ],
      " ",
    )
  }

  return joinStrings(
    [
      getHighlightValue(highlights, "businessName", businessName),
      title,
      getHighlightValue(highlights, "firstName", firstName),
      getHighlightValue(highlights, "lastName", lastName),
    ],
    " ",
  )
}
